module.exports = __webpack_public_path__ + "static/media/download.a0185b04.svg";